import React, { useEffect, useState } from "react";
import "@/styles/layout/header.scss";
import Container from "@/components/container/Container";
import { Link, NavLink, useNavigate } from "react-router-dom";
import ButtonComponent from "@/components/button/Button";
import IconHamburger from "@/components/icons/IconHamburger";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsLoggedIn,
  getUserInfo,
  setCurrentForm,
  setIsMiniDashboardOpen,
  setModalOpen,
} from "@/reducers/commonSlice";
import IconCross from "@/components/icons/IconCross";
import { Badge, Popover } from "antd";
import { getIsGuidePanel } from "@/reducers/guideSlice";
import {
  getAllPushNotificaions,
  markNotificationAsRead,
} from "@/services/services/pushNotificaion";
import NotificationList from "@/components/notifications/NotificaionsList";
import IconNotification from "@/components/icons/IconNotification";
import { useSearchParams } from "react-router-dom";

const menuLinks = [
  { label: "Home", path: "/", isProtected: false },
  { label: "Mentors", path: "/guides", isProtected: false },
  { label: "Sessions", path: "/sessions", isProtected: true },
  { label: "Plans", path: "/plans", isProtected: false },
  { label: "Dashboard", path: "/dashboard", isProtected: true },
  { label: "Blogs", path: "/blogs", isProtected: false },
];

const guideLinks = [
  { label: "Home", path: "/" },
  { label: "Sessions", path: "/sessions" },
  { label: "Membership", path: "/membership" },
  { label: "Dashboard", path: "/dashboard" },
  { label: "Blogs", path: "/blogs", isProtected: false },
];

const otherLinks = [
  { label: "Profile", path: "/profile" },
  { label: "Site Setting", path: "/setting" },
  { label: "View Transactions", path: "/transactions" },
];

// const notificaions = [
//   {title: "New Session Request", message: "You have a new session request from John Doe", id: 1, time: "10:00 AM", date: "12/12/2023"},
//   {title: "Session1 Reminder", message: "You have a session with John1 Doe in 1 hour", id: 2, time: "11:00 AM", date: "12/12/2024"},
//   {title: "Session2 Reminder", message: "You have a session with John2 Doe in 1 hour", id: 3, time: "12:00 AM", date: "12/12/2022"},
//   {title: "Session3 Reminder", message: "You have a session with John3 Doe in 1 hour", id: 4, time: "01:00 AM", date: "12/12/2023"},
//   {title: "Session3 Reminder", message: "You have a session with John3 Doe in 1 hour", id: 4, time: "01:00 AM", date: "12/12/2023"},
//   {title: "Session3 Reminder", message: "You have a session with John3 Doe in 1 hour", id: 4, time: "01:00 AM", date: "12/12/2023"},
// ]
const Header = () => {
  const [searchParams] = useSearchParams();
  const data = searchParams.get("data");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isGuidePanel = useSelector(getIsGuidePanel);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [notificaionOpen, setNotificaionOpen] = useState(false);
  const [allPushNotificaions, setAllPushNotificaions] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const linkArray = isGuidePanel ? guideLinks : menuLinks;
  const otherLinksArray = isGuidePanel
    ? otherLinks.filter((x) => x.path !== "/transactions")
    : otherLinks;
  const userData = useSelector(getUserInfo);

  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  const handleNotificaionOpenChange = (newOpen) => {
    setNotificaionOpen(newOpen);
  };
  const handleNotificationClick = (clickedItem) => {
    // console.log("clickedItem", clickedItem);
    setAllPushNotificaions((prev) =>
      prev.map((item) => (item.id === clickedItem.id ? { ...item, read: true } : item))
    );
    markNotificationAsRead(clickedItem.id);
    setNotificaionOpen(false);
  };
  const getUnreadNotificaionsCount = (notificaions) => {
    return notificaions.filter((x) => !x.read).length;
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const content = (
    <div className="menulink-popover">
      <Link to="/profile" onClick={hide}>
        My Profile
      </Link>
      <Link to="/setting" onClick={hide}>
        Site Setting
      </Link>
      {!isGuidePanel ? (
        <Link to="/transactions" onClick={hide}>
          View Transactions
        </Link>
      ) : (
        <></>
      )}
    </div>
  );

  const handleOnBoarding = (type) => {
    dispatch(setModalOpen(true));
    dispatch(setCurrentForm(type));
  };

  const handleResize = () => {
    if (window.innerWidth < 992) {
    } else if (window.innerWidth >= 1024) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(false);
    }
  };

  // Modifying handleResize to update windowWidth state
  const handleResizeWithWidthUpdate = () => {
    setWindowWidth(window.innerWidth);
    handleResize();
  };

  useEffect(() => {
    window.addEventListener("resize", handleResizeWithWidthUpdate);
    return () => {
      window.removeEventListener("resize", handleResizeWithWidthUpdate);
    };
  });
  useEffect(() => {
    if (isLoggedIn) {
      getAllPushNotificaions()
        .then((res) => {
          // console.log("All push notifications:", res);
          const sortedNotifications = res.rows.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllPushNotificaions(sortedNotifications);
        })
        .catch((err) => {
          // console.log("Error in getting all push notifications:", err);
        });
    }
  }, [isLoggedIn]);

  // Adding the handleDashboardClick function
  const handleDashboardClick = () => {
    if (!window.location.pathname?.includes("checkout" || "meeting")) {
      dispatch(setIsMiniDashboardOpen(true));
    }
  };

  // scroll lock when menu is open
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [sidebarOpen]);

  const [isDataParams, setIsDataParams] = useState(false);
  useEffect(() => {
    // console.log(data);
    if (data) {
      setIsDataParams(true);
    }
  }, [data]);

  if (isDataParams) return null;

  return (
    <Container className="navbar">
      {/* <div> */}
      <div
        className="logo-section cursor-pointer"
        style={{ height: "30px", maxWidth: "100px" }}
        onClick={() => navigate("/")}
      >
        <img src="/assets/images/logo.png" alt="inforens" />
      </div>
      {/* </div> */}
      <div className="menu-item">
        {linkArray
          .filter((x) => (!!x.isProtected ? (isLoggedIn ? true : false) : true))
          .filter((x) => (x.label === "Dashboard" && windowWidth >= 992 ? false : true))
          ?.map((item) => {
            return (
              <NavLink
                to={item.path}
                key={item.label}
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={(e) => {
                  if (window.location.pathname == "/checkout") {
                    e.preventDefault();
                  }
                }}
              >
                {item.label}
              </NavLink>
            );
          })}
        {windowWidth >= 992 && isLoggedIn ? (
          <a
            href="/dashboard"
            className={window.location.pathname.includes("dashboard") ? "active" : ""}
            onClick={(e) => {
              if (window.location.pathname == "/checkout") {
                e.preventDefault();
              }
              if (window.location.pathname !== "/dashboard") {
                e.preventDefault();
                handleDashboardClick();
              }
            }}
          >
            Dashboard
          </a>
        ) : (
          <></>
        )}
      </div>
      <div className="profile-setting-section">
        {isLoggedIn ? (
          <>
            <div
              className="notificaionPopover"
              style={{
                alignItems: "center",
                display: "flex",
                marginRight: "10px",
              }}
            >
              <Popover
                placement={windowWidth >= 992 ? "bottomRight" : "top"}
                content={NotificationList({
                  allPushNotificaions,
                  handleNotificationClick,
                })}
                open={notificaionOpen}
                trigger="click"
                onOpenChange={handleNotificaionOpenChange}
                onClick={(e) => e.stopPropagation()}
                overlayStyle={{
                  maxWidth: windowWidth >= 992 ? "500px" : "300px",
                }}
              >
                <Badge
                  size="small"
                  count={getUnreadNotificaionsCount(allPushNotificaions)}
                  className="small-badge"
                  offset={[-2, 0]}
                >
                  <IconNotification style={{ fontSize: "18px" }} />
                </Badge>
              </Popover>
            </div>
            <div className="profile-pic">
              <Popover
                placement="bottomRight"
                content={content}
                open={open}
                trigger="click"
                onOpenChange={handleOpenChange}
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={
                    userData.profileImgUrl
                      ? userData.profileImgUrl
                      : "/assets/images/defaultProfile.jpeg"
                  }
                  height={"40px"}
                  width={"40px"}
                  style={{ borderRadius: "50%" }}
                  alt="profile"
                />
              </Popover>
            </div>
          </>
        ) : (
          <>
            <ButtonComponent
              label="Sign In"
              onClick={() => handleOnBoarding("signIn")}
              className="hide-on-mobile"
            />
            <ButtonComponent
              varient="primary"
              label="Sign Up"
              onClick={() => handleOnBoarding("requestOTP")}
              className="hide-on-mobile"
            />
          </>
        )}
      </div>

      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="close cursor-pointer" onClick={toggleSidebar}>
          <IconCross width={50} height={50} />
        </div>
        <div className="menu-item" onClick={toggleSidebar}>
          {linkArray
            ?.filter((x) => (!!x.isProtected ? (isLoggedIn ? true : false) : true))
            .map((item) => {
              return (
                <NavLink
                  to={item.path}
                  key={item.label}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {item.label}
                </NavLink>
              );
            })}
          {isLoggedIn ? (
            otherLinksArray?.map((item) => {
              return (
                <NavLink
                  to={item.path}
                  key={item.label}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {item.label}
                </NavLink>
              );
            })
          ) : (
            <></>
          )}
        </div>
        {!isLoggedIn ? (
          <div className="profile-setting-section">
            <ButtonComponent
              label="Sign In"
              onClick={() => handleOnBoarding("signIn")}
              className={!sidebarOpen && "hide-on-mobile"}
            />
            <ButtonComponent
              varient="primary"
              label="Sign Up"
              onClick={() => handleOnBoarding("requestOTP")}
              className={!sidebarOpen && "hide-on-mobile"}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="menu-icon cursor-pointer" onClick={toggleSidebar}>
        <IconHamburger />
      </div>
    </Container>
  );
};

export default Header;
